module.exports = __webpack_public_path__ + "img/phone.cebb63af.svg";